import { useState, useEffect } from 'react'
import * as R from 'ramda'

const useIsHovered = el => {
  const [isHovered, setIsHovered] = useState()

  const onHover = () => setIsHovered(true)
  const onHoverStop = () => setIsHovered(false)

  useEffect(() => {
    if (R.is(Node, el)) {
      el.addEventListener('mouseenter', onHover)
      el.addEventListener('mouseleave', onHoverStop)
    }

    return () => {
      if (R.is(Node, el)) {
        el.removeEventListener('mouseenter', onHover)
        el.removeEventListener('mouseleave', onHoverStop)
      }
    }
  }, [el])

  return isHovered
}

export default useIsHovered
